export function normalizeConceptsList(raw) {
  if (!raw) return []
  if (!Array.isArray(raw)) return []
  const seen = new Set()
  const out = []
  raw.forEach((item) => {
    const label = String(item || '').trim()
    if (!label) return
    const key = label.toLowerCase()
    if (seen.has(key)) return
    seen.add(key)
    out.push(label)
  })
  return out
}

export function mergeConceptOptions(existing, selected) {
  const seen = new Set()
  const out = []
  ;[...(existing || []), ...(selected || [])].forEach((item) => {
    const label = String(item || '').trim()
    if (!label) return
    const key = label.toLowerCase()
    if (seen.has(key)) return
    seen.add(key)
    out.push(label)
  })
  return out.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
}

export const DEFAULT_SCHOOL_REVIEW_TEMPLATE =
  '<p><strong>Requirements:</strong></p><p><br></p><p><strong>Feedbacks:</strong></p><p><br></p><p><strong>Revisits:</strong></p><p><br></p><p><strong>Others:</strong></p>'

export function stripHtml(html) {
  return String(html || '')
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

function escapeHtml(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export function filterFilledReviewSections(html) {
  if (!html || typeof html !== 'string') return ''

  const sectionRegex =
    /<p><strong>([^<:]+):<\/strong><\/p>([\s\S]*?)(?=<p><strong>[^<:]+:<\/strong><\/p>|$)/gi
  const sections = []
  let match = sectionRegex.exec(html)
  while (match) {
    const title = match[1].trim()
    const bodyHtml = match[2]
    if (stripHtml(bodyHtml)) {
      sections.push(`<p><strong>${escapeHtml(title)}:</strong></p>${bodyHtml}`)
    }
    match = sectionRegex.exec(html)
  }

  if (sections.length) return sections.join('')

  return stripHtml(html) ? html : ''
}

export function initialReviewCheckedConcepts(planned, explained) {
  const plannedList = normalizeConceptsList(planned)
  if (!plannedList.length) return []
  const explainedList = normalizeConceptsList(explained)
  if (explainedList.length) {
    const plannedKeys = new Set(plannedList.map((c) => c.toLowerCase()))
    return explainedList.filter((c) => plannedKeys.has(c.toLowerCase()))
  }
  return [...plannedList]
}

export function isConceptChecked(checkedList, concept) {
  const key = String(concept || '').toLowerCase()
  return checkedList.some((c) => c.toLowerCase() === key)
}

export function toggleReviewConcept(checkedList, concept) {
  const key = String(concept || '').toLowerCase()
  if (checkedList.some((c) => c.toLowerCase() === key)) {
    return checkedList.filter((c) => c.toLowerCase() !== key)
  }
  return [...checkedList, concept]
}
